import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { GridTargetsBase } from '../grid-target-base';
import { getCheckinDayBasicConfig } from './basic-config';
import { areEqual } from '../components/utility';

export const CheckinDayTargetSetting = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const {
    data, setData, patchErrMsg, patchTargetsApiErrMsg, apiErrors,
  } = props;

  const params = {
    ...getCheckinDayBasicConfig(i18n),
    validateParams: { targetId: 'check-in-day-target-wrapper', patchErrMsg, targetName: 'checkinDay' },
    patchTargetsApiErrMsg,
    apiErrors,
  };

  return (
    <div id="check-in-day-target-wrapper">
      <GridTargetsBase data={data} setData={setData} {...params} />
    </div>
  );
}, areEqual);

CheckinDayTargetSetting.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func.isRequired,
  patchErrMsg: PropTypes.func,
  patchTargetsApiErrMsg: PropTypes.func,
  apiErrors: PropTypes.arrayOf(PropTypes.string),
};
CheckinDayTargetSetting.defaultProps = {
  patchErrMsg() {},
  patchTargetsApiErrMsg() {},
  apiErrors: [],
};
